import {useState} from 'react';

//types
import {RfElementType} from '@stencil/hotels-cg-reducer/src/details/types';

//components
import Filter from '../Filter/Filter';
import FiltersGroupItem from './FilterGroupItem';

//styles
import * as S from './FiltersGroup.styles';

const FiltersGroup = ({
  setFilters,
  currentFilters = [],
  currentFiltersCopy = [],
  setFiltersCopy,
  roomFilterGroup = [],
}: {
  setFilters: Function;
  currentFilters: Array<RfElementType>;
  setFiltersCopy: Function;
  currentFiltersCopy: Array<RfElementType>;
  roomFilterGroup: Array<RfElementType>;
}) => {
  // const roomFilterGroup= useSelector(roomGroupFilters);

  const [showRoomType, setShowRoomType] = useState(false);
  const [active, setActive] = useState(-1);
  const [groupFilters, setGroupFilters] = useState(currentFilters);

  const handleShowRoomType = () => {
    setShowRoomType(!showRoomType);
  };

  const isFilterActive = selectedFilter => {
    let isActive = false;
    let arr = currentFilters.filter(item => item?.code === selectedFilter?.code);
    if (arr?.length > 0) {
      isActive = true;
    }
    return isActive;
  };

  const changeFilter = () => {};

  if (!roomFilterGroup || roomFilterGroup?.length == 0) return null;

  return (
    <S.FilterList id={UpsellFilterWrapperId}>
      <S.FilterByText>Filter Type</S.FilterByText>
      {roomFilterGroup.map((data, index) => {
        return data?.isGroupApplicable && data?.ratePlanFilterList?.length > 1 ? (
          <FiltersGroupItem
            index={index}
            setFilters={setFiltersCopy}
            currentFilters={currentFiltersCopy}
            appliedFiltersList={currentFilters}
            setFiltersOnApply={setFilters}
            data={data}
          />
        ) : (
          <li
            key={index}
            onClick={() => setActive(index)}
            style={{
              padding: '1px 0px',
              border: 'none',
            }}
          >
            <Filter
              setFilters={setFilters}
              currentFilters={currentFilters}
              roomFilterList={data?.ratePlanFilterList}
              customOuterWrapperPadding={'0px'}
              customInnerWrapperPadding={'0.7rem 10px'}
              // hideCheckBox={true}
              isActive={isFilterActive(data?.ratePlanFilterList?.[0])}
              textColor={isFilterActive(data?.ratePlanFilterList?.[0]) ? '#fff' : '#1958B6'}
            />
          </li>
        );
      })}
    </S.FilterList>
  );
};

export default FiltersGroup;
export const UpsellFilterWrapperId = 'details-filters-outer-wrapper';
